<template>
  <div ref="wrapperRef">
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue';
  import { useClientSize } from '@/composables/useClientSize';

  const wrapperRef = ref<HTMLElement | null>(null);
  const { isMobile } = useClientSize();
  let previousScrollY: number | null = null;

  const adjustScroll = () => {
    if (wrapperRef.value) {
      const newHeight = wrapperRef.value.offsetHeight;

      if (wrapperRef.value.offsetHeight === 0) {
        return;
      }

      if (previousScrollY !== null) {
        const heightDifference = newHeight - previousScrollY;
        window.scrollBy(0, heightDifference);
      }

      previousScrollY = newHeight;
    }
  };

  const resizeObserver = new ResizeObserver(() => {
    adjustScroll();
  });

  onMounted(() => {
    if (isMobile.value && wrapperRef.value) {
      resizeObserver.observe(wrapperRef.value);
    }
  });

  onUnmounted(() => {
    if (isMobile.value && wrapperRef.value) {
      resizeObserver.unobserve(wrapperRef.value);
    }
  });
</script>

<style scoped></style>
